export default __webpack_public_path__ + "static/media/cwpos-green.38af37d2.png";